import { defineStore } from 'pinia'

import {
  burnToken,
  changeTokenAdmin,
  createNewToken,
  mintToken,
  transferToken,
  transferMultiToken,
  updateTokenMetadata,
  createTokenPair
} from './message'
import { fetchParams, fetchToken, fetchTokens } from './fetch'
import { TokenFactoryModuleParams } from '@injectivelabs/sdk-ts'

type TokenStoreState = {
  params: TokenFactoryModuleParams
  userTokens: (any & { admin: string; suply: string })[]
  chainTokens: any[]
}

const initialStateFactory = (): TokenStoreState => ({
  params: { denomCreationFee: [] },
  userTokens: [],
  chainTokens: []
})

export const useTokenStore = defineStore('token', {
  state: (): TokenStoreState => initialStateFactory(),
  getters: {
    tokens: (state) => {
      return [...state.userTokens, ...state.chainTokens] as {
        denom: string
        symbol: string
        tokenType: any
        decimals: number | undefined
      }[]
    }
  },
  actions: {
    createNewToken,
    updateTokenMetadata,
    mintToken,
    burnToken,
    transferToken,
    transferMultiToken,
    changeTokenAdmin,
    createTokenPair,

    fetchParams,

    fetchTokens,
    fetchToken,

    reset() {
      useTokenStore().$reset()
    }
  }
})
